import Vue from 'vue';
import { State } from '@/stores/orders/state';
import { MutationTree } from 'vuex';
import { Order } from '@/models/order';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setOrders = (state: State, orders: Array<Order>) => {
        state.orders = orders;
    }
    public setPage = (state: State, page: number) => {
        state.pageNumber = page;
    }
    public setCurrentPageSize = (state: State, pageSize: number) => {
        state.pageSize = pageSize;
    }
    public setTotalPages = (state: State, pageCount: number) => {
        state.totalPages = pageCount;
    }
    public setTotal = (state: State, totalRecords: number) => {
        state.total = totalRecords;
    }
    public setFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.filterStatus = filterStatus;
    }
    public setFrom = (state: State, from: string | null) => {
        state.from = from;
    }
    public setTo = (state: State, to: string | null) => {
        state.to = to;
    }
}
